import { Organization } from "@/modules/organizations/entities/Organization"
import { OrganizationStatus } from "@/modules/organizations/enums/organization-status"
import {
    CreateOrganizationDto,
    UpdateOrganizationDto,
} from "@/modules/organizations/infrastructure/organization-service"
import { PlanType } from "@/modules/organizations/types/plan-type"
import type MockAdapter from "axios-mock-adapter"

const now = () => new Date().toISOString()

export let mockOrganizations: Organization[] = [
    {
        id: "org-1",
        name: "Acme Recruitment",
        plan: PlanType.Recruitment,
        currency: 'USD',
        physicalAddress: {
            line1: "123 Mock Street",
            line2: "Suite 100",
            city: "Cape Town",
            state: "Western Cape",
            country: "South Africa",
            postalCode: "8000",
        },
        status: OrganizationStatus.Active,
        createdAt: now(),
        updatedAt: now(),
    },
    {
        id: "org-2",
        name: "Globex HR Suite",
        plan: PlanType.FullHiring,
        currency: 'ZAR',
        physicalAddress: {
            line1: "456 Fake Avenue",
            city: "Johannesburg",
            state: "Gauteng",
            country: "South Africa",
            postalCode: "2000",
        },
        status: OrganizationStatus.Active,
        createdAt: now(),
        updatedAt: now(),
    },
]

function createId() {
    return `org-${Math.random().toString(36).slice(2, 9)}`
}

export function registerOrgMocks(mock: MockAdapter) {
    mock.onGet("/organization").reply(() => {
        return [200, mockOrganizations]
    })

    mock.onPost("/organizations").reply((config) => {
        const body = JSON.parse(config.data ?? "{}") as CreateOrganizationDto

        const newOrg: Organization = {
            id: createId(),
            name: body.name,
            plan: body.plan,
            physicalAddress: body.physicalAddress,
            status: OrganizationStatus.Active,
            createdAt: now(),
            updatedAt: now(),
            currency: ''
        }

        mockOrganizations = [...mockOrganizations, newOrg]

        return [201, newOrg]
    })

    mock.onPut(/\/organizations\/[^/]+$/).reply((config) => {
        const id = config.url?.split("/").pop()
        if (!id) return [400, { message: "Invalid organisation id" }]

        const body = JSON.parse(config.data ?? "{}") as UpdateOrganizationDto

        const existing = mockOrganizations.find((o) => o.id === id)
        if (!existing) {
            return [404, { message: "Organisation not found" }]
        }

        const updated: Organization = {
            ...existing,
            ...body,
            physicalAddress: {
                ...existing.physicalAddress,
                ...(body.physicalAddress ?? {}),
            },
            updatedAt: now(),
        }

        mockOrganizations = mockOrganizations.map((o) =>
            o.id === id ? updated : o,
        )

        return [200, updated]
    })

    mock.onDelete(/\/organizations\/[^/]+$/).reply((config) => {
        const id = config.url?.split("/").pop()
        if (!id) return [400, { message: "Invalid organisation id" }]

        const exists = mockOrganizations.some((o) => o.id === id)
        if (!exists) {
            return [404, { message: "Organisation not found" }]
        }

        mockOrganizations = mockOrganizations.filter((o) => o.id !== id)

        return [204]
    })
}
